import { CaretDownOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Dropdown, List } from 'antd';
import React from 'react';
import { testCaseDifficultyMap } from './QuestionTab';
import styles from './QuestionTab.scss';

const TestCaseList = ({ testCases }) => {
  const download = (data, name) => {
    const blob = new Blob([data], { type: 'text/plain' });
    const link = document.createElement('a');
    link.download = name;
    link.href = URL.createObjectURL(blob);
    link.click();
  };
  const view = data => {
    const w = window.open();
    w.document.write(data);
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={testCases}
      renderItem={(item, i) => (
        <List.Item>
          <List.Item.Meta
            title={
              <div className={styles['question-tab__listItem']}>
                <div>
                  <div>Name: {item.description || `Test Case ${i + 1}`}</div>
                  <div>Difficulty: {testCaseDifficultyMap[item.difficulty]}</div>
                </div>
                <div>
                  <div>Visibility: {item.visible ? 'Visible' : 'Hidden'}</div>
                  <div>Points: {item.points}</div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                    onClick={() => {
                      download(item.stdin, 'stdin.txt');
                      download(item.stdout, 'stdout.txt');
                    }}
                  >
                    <DownloadOutlined />
                  </Button>
                  <Dropdown
                    menu={{
                      items: [
                        { key: 'input', label: 'Input', onClick: () => view(item.stdin) },
                        { key: 'output', label: 'Output', onClick: () => view(item.stdout) },
                      ],
                    }}
                  >
                    <Button>
                      <EyeOutlined />
                      <CaretDownOutlined />
                    </Button>
                  </Dropdown>
                </div>
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default TestCaseList;
